'use client';

import React from 'react';

import { Box, Flex } from '@chakra-ui/react';

// import { PrimaryButton } from '@components/custom-buttons';
import { SlotToBook } from '@modules/find-mentor/types';
import { getAMPMTime } from '@utils/date';

type AvailableSlotProps = {
    slot: SlotToBook;
    onNextClick: () => void;
    onSelect: () => void;
};

const AvailableSlot = ({ slot, onNextClick, onSelect }: AvailableSlotProps) => (
    <>
        {!slot.isSelected ? (
            <Box
                cursor="pointer"
                width="100%"
                borderRadius="6px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                py="10px"
                px="14px"
                borderWidth={1}
                fontWeight={500}
                borderColor="border"
                color={slot.isSelected ? 'primary.light' : 'mainText'}
                bgColor={slot.isSelected ? 'lightBlueBg' : 'transparent'}
                as="button"
                onClick={onSelect}
                fontSize="14px"
                lineHeight="20px"
            >
                {getAMPMTime(slot.startTime, true)}
            </Box>
        ) : (
            <Flex gap={2} width="100%">
                <Box
                    width="100%"
                    borderRadius="6px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    py="10px"
                    px="14px"
                    borderWidth={1}
                    fontWeight={500}
                    borderColor="border"
                    color="primary.light"
                    bgColor="lightBlueBg"
                    fontSize="14px"
                    lineHeight="20px"
                >
                    {getAMPMTime(slot.startTime, true)}
                </Box>
                {/* <PrimaryButton
                    width="50%"
                    height="49px"
                    buttonLabel="Next"
                    type="button"
                    onClick={onNextClick}
                /> */}
            </Flex>
        )}
    </>
);

export default AvailableSlot;
